import { type FunctionalComponent, h, type VNode } from '@stencil/core';
import { getActiveBreakpoints } from '../../../../utils/media';
import type { GuidedV2Emitters } from '../../models/eventNames';
import { Brands } from '../../../../constants/brands';

interface IMegaBannerGenAI{
  eventEmitters: GuidedV2Emitters;
  description?: string;
  text: string;
  buttonText?: string;
  href: string;
  target?: string | undefined;
  searchTerm: string;
  brand?: string;
}

export const MegaBannerGenAI: FunctionalComponent<IMegaBannerGenAI> = (props) => {
    const { text, buttonText, href, target, description, eventEmitters, searchTerm, brand } = props;
    const { bannerClicked } = eventEmitters() ?? {};
    const storageActions = [{ key: 'conversational_search_chat_visibility', value: 'true' }];
    const customEvents = [
      { name: 'conversational-search:cta-action', detail: { isChatVisible: true, isGuidedSearch: true } },
      { name: 'conversational-search:ga-cta-banner-clicked', detail: { isGuided: true, keyword: searchTerm, clickedArea: searchTerm } }
    ];

    const customBannerClickedEvent = { name: 'conversational-search:banner-clicked' };
    const hrefWithSearchTerm = (() => {
        const url = new URL(href);

        url.searchParams.set('q', searchTerm);

        return url.toString();
    })();

    const genAIOnClickCallbacks = () => {
        storageActions.forEach(({ key, value }) => sessionStorage.setItem(key, value));
        customEvents.forEach(({ name, detail }) => window.dispatchEvent(new CustomEvent(name, { detail })));
    };

    const handleMobileClick = () => {
        if (!getActiveBreakpoints().medium) {
          genAIOnClickCallbacks();
          const clickEvent = bannerClicked?.emit?.({ url: hrefWithSearchTerm });
          if (!clickEvent.defaultPrevented) {
            window.open(hrefWithSearchTerm, target);
          }
        }
    };

    const handleBtnClick = (event) => {
        if(brand && brand == Brands.MYSCHNEIDER){
          window.dispatchEvent(new CustomEvent(customBannerClickedEvent.name, {}));
          genAIOnClickCallbacks();
          event.preventDefault();
          event.stopImmediatePropagation();
        }else{
          const clickEvent = bannerClicked?.emit?.({ url: hrefWithSearchTerm });
          genAIOnClickCallbacks();
          if (clickEvent.defaultPrevented) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }
    };

    return (
    <div class="mega-banner__container" onClick={handleMobileClick}>
      <div class="mega-banner__text-section">
        {text && <h3 class="mega-banner__title">{text}</h3>}
        {description && <div class="mega-banner__subtitle">{description} </div>}
      </div>
      {buttonText && (
        <qds-button
          class="mega-banner__button"
          size="large"
          href={hrefWithSearchTerm}
          importance="emphasized"
          text={buttonText}
          target={target}
          onClickCapture={handleBtnClick}
        ></qds-button>
      )}
    </div>
  ) as VNode;
};
